import { motion } from "framer-motion";
import { Typography, Container, Card, Box, Grid, Button } from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import gif1 from "../Assets/consulting2.gif";
import gif2 from "../Assets/servinow2.gif";
import gif3 from "../Assets/staffing2.gif";
import gif4 from "../Assets/webdev2.gif";
import Footer from "./Footer";
const CustomCard = styled(motion(Card))({
    minHeight: "350px",
    padding: "20px",
    textAlign: "center",
    borderRadius: "12px",
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(52, 39, 153, 0.13)",
    boxShadow: "0px 4px 20px rgba(29, 7, 70, 0.67)",
    border: "1px solid rgba(29, 7, 70, 0.67)",
    color: "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between"
});

const CardContainer = styled(Container)({ marginTop: "10px" });

const GlowButton = styled(Button)({
    marginTop: "15px",
    padding: "10px 20px",
    borderRadius: "8px",
    border: "1px solid rgba(0, 123, 255, 0.8)",
    color: "#007bff",
    backgroundColor: "transparent",
    transition: "0.3s",
    '&:hover': {
        backgroundColor: "rgba(0, 123, 255, 0.2)",
        boxShadow: "0px 0px 15px rgba(0, 123, 255, 0.8)"
    }
});



const services = [
    { title: "Consultancy", gif: gif1, link: "/services/consultancy" },
    { title: "Staffing", gif: gif3, link: "/services/staffing" },
    { title: "Web Development", gif: gif4, link: "/services/web-dev" },
    { title: "ServiceNow", gif: gif2, link: "/services/servicenow" }
];

const ServicesSection = () => {
    const navigate = useNavigate();
    return (
        <>
            <CardContainer>
                <motion.div
                    whileHover={{
                        textShadow: "0px 0px 70px rgb(8, 53, 99)",
                        transition: { duration: 0.5 },
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{ color: "#95a9bd", fontFamily: "'Inter', sans-serif", textAlign: "center", mb: 4 }}
                    >
                        Our Services
                    </Typography>
                </motion.div>

                <Grid container spacing={3}>
                    {services.map((service, index) => (
                        <Grid
                            item
                            xs={12}
                            md={6}
                            key={index}
                            sx={{
                                mt: index >= 2 ? 6 : 0,
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            <CustomCard
                                initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.8, ease: "easeOut" }}
                                viewport={{ once: true }}
                                whileHover={{
                                    boxShadow: "0px 0px 20px rgba(26, 55, 219, 0.9), 0px 0px 40px rgba(8, 6, 104, 0.6)",
                                    transition: { duration: 0.3 }
                                }}
                                sx={{
                                    height: "100%", // Ensure the card takes full height of the grid item
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between" // Space out content evenly
                                }}
                            >
                                <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    {/* GIF Container */}
                                    <Box sx={{ width: "150px", height: "150px", overflow: "hidden", display: "flex", justifyContent: "center" }}>
                                        <img
                                            src={service.gif}
                                            alt={`${service.title} GIF`}
                                            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }}
                                        />
                                    </Box>

                                    {/* Title */}
                                    <Typography variant="h5" sx={{ color: "#007bff", fontFamily: "'Inter', sans-serif", mt: 2 }}>
                                        {service.title}
                                    </Typography>

                                    {/* Learn More Button */}
                                    <GlowButton onClick={() => navigate(service.link)}>Learn More</GlowButton>
                                </Box>
                            </CustomCard>
                        </Grid>
                    ))}
                </Grid>
            </CardContainer>

            <Footer />
        </>
    );
};

export default ServicesSection;